var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAltiboxBoxNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 72.1",
    style: {
      enableBackground: "new 0 0 283.5 72.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.3,70.8V7.5h11.4v63.3H60.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.2,
    y: 21.9,
    className: "st0",
    width: 11.4,
    height: 48.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.6,70.8h-11.4V7.5h11.4v19.9c3.7-4.8,10.7-6.8,15.1-6.8c3.7,0,7.1,0.7,10.2,2c3.1,1.4,5.7,3.2,7.9,5.6 c2.2,2.4,3.9,5.1,5.1,8.2c1.2,3.1,1.8,6.4,1.8,9.8c0,3.5-0.6,6.8-1.8,9.8c-1.2,3.1-2.9,5.8-5.1,8.2c-2.2,2.4-4.8,4.3-7.9,5.6 c-3.1,1.4-6.5,2-10.1,2v0c-4.4,0-11.4-2-15.1-6.8V70.8z M145.6,46.4c0,2.1,0.3,4.1,1,6c0.7,1.9,1.6,3.5,2.9,4.9 c1.2,1.4,2.8,2.5,4.5,3.4c1.8,0.8,3.8,1.3,6,1.3c2.2,0,4.1-0.4,5.9-1.3c1.8-0.8,3.3-2,4.5-3.4c1.3-1.4,2.2-3,2.9-4.9 c0.7-1.9,1-3.9,1-6c0-2.1-0.3-4.1-1-6c-0.7-1.9-1.6-3.5-2.9-4.9c-1.3-1.4-2.8-2.5-4.5-3.4c-1.7-0.8-3.7-1.3-5.9-1.3 c-2.3,0-4.3,0.4-6,1.3c-1.8,0.8-3.3,2-4.5,3.4c-1.2,1.4-2.2,3-2.9,4.9C145.9,42.3,145.6,44.2,145.6,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.3,70.8l16-24.6l-15.6-24.2h13.2l9,15.3l9-15.3h13.2l-15.6,24.2l15.9,24.6h-13.2l-9.3-15.7l-9.4,15.7 H238.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215,20.7c-14,0-25.4,11.4-25.4,25.4S201,71.4,215,71.4c14,0,25.4-11.4,25.4-25.4S229,20.7,215,20.7z  M215,60.6c-8,0-14.6-6.5-14.6-14.6c0-8,6.5-14.6,14.6-14.6c8,0,14.6,6.5,14.6,14.6C229.5,54.1,223,60.6,215,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.3,56.1c0,8.5,6.3,14.7,14.1,14.7h4.9V60.7h-2.1c-3,0-5.5-2.5-5.5-5.6v-4V31.5h7.6v-9.5h-7.6V7.5H85.3 v14.4h-7.5v9.5h7.5v22.7L85.3,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,7.9c0,4.4,3.5,7.9,7.9,7.9c4.4,0,7.9-3.5,7.9-7.9c0-4.4-3.5-7.9-7.9-7.9C114.5,0,111,3.5,111,7.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,20.7C25,20.7,25,20.7,25,20.7L25,20.7L25,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,72.1L25,72.1C25,72.1,25,72.1,25,72.1L25,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,21.9v5.5c-3.7-4.8-10.8-6.8-15.1-6.8c-3.7,0-7.1,0.7-10.1,2c-3.1,1.4-5.7,3.2-7.9,5.6 c-2.2,2.4-3.9,5.1-5.1,8.2C0.6,39.7,0,43,0,46.4c0,3.5,0.6,6.8,1.8,9.8C3.1,59.3,4.8,62,7,64.4c2.2,2.4,4.8,4.3,7.9,5.6 c3,1.4,6.4,2,10.1,2c4.4,0,11.5-2,15.1-6.8v5.5h11.4V21.9H40.1z M39.1,52.3c-0.7,1.9-1.7,3.5-2.9,4.9c-1.2,1.4-2.8,2.5-4.6,3.4 c-1.8,0.8-3.8,1.3-5.9,1.3c-2.2,0-4.1-0.4-5.9-1.3c-1.8-0.8-3.3-2-4.5-3.4c-1.3-1.4-2.2-3-2.9-4.9c-0.7-1.9-1-3.9-1-6 c0-2.1,0.3-4.1,1-6c0.7-1.9,1.6-3.5,2.9-4.9c1.3-1.4,2.8-2.5,4.5-3.4c1.8-0.8,3.7-1.3,5.9-1.3c2.2,0,4.1,0.4,5.9,1.3 c1.8,0.8,3.3,2,4.6,3.4c1.2,1.4,2.2,3,2.9,4.9c0.7,1.9,1,3.9,1,6C40.1,48.4,39.8,50.4,39.1,52.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltiboxBoxNegative);
export default __webpack_public_path__ + "static/media/altibox-box-negative.6f5a050c21cb03b0f6d654edf1e3e5e1.svg";
export { ForwardRef as ReactComponent };